// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageInput {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  position: relative;
}
.ImageInput .ImageInput-Placeholder {
  opacity: 1;
  transition: opacity 0.5s;
}
.ImageInput:not(.ImageInput-Disabled):focus-within .ImageInput-Placeholder, .ImageInput:not(.ImageInput-Disabled):has(.ImageInput-Button:hover) .ImageInput-Placeholder {
  opacity: 0;
}
.ImageInput.ImageInput-Disabled .ImageInput-Button {
  cursor: default;
}
.ImageInput.ImageInput-Disabled .ImageInput-Button:hover {
  background: rgba(0, 0, 0, 0);
}
.ImageInput.ImageInput-Disabled .ImageInput-Button:hover > i {
  opacity: 0;
}
.ImageInput .ImageInput-Progress {
  position: absolute;
  width: 100%;
  transition: 1s height background;
  font-size: 1rem;
  color: #fff;
  text-align: center;
}
.ImageInput .ImageInput-Display {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow: hidden;
  background-size: cover;
  background-position: center;
}
.ImageInput .ImageInput-Display .ImageInput-Overlay {
  position: absolute;
  width: 100%;
  height: 100%;
}
.ImageInput .ImageInput-Display .ImageInput-Overlay .ImageInput-Button {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0);
  transition: background 0.5s;
  border: none;
  font-size: inherit;
}
.ImageInput .ImageInput-Display .ImageInput-Overlay .ImageInput-Button > i {
  opacity: 0;
  transition: opacity 0.5s;
  color: #fff;
}
.ImageInput .ImageInput-Display .ImageInput-Overlay .ImageInput-Button:hover {
  background: rgba(0, 0, 0, 0.25);
}
.ImageInput .ImageInput-Display .ImageInput-Overlay .ImageInput-Button:hover > i {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/common/ImageInput/styles.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAFF;AAGE;EACE,UAAA;EACA,wBAAA;AADJ;AAMM;EACE,UAAA;AAJR;AAQE;EACE,eAAA;AANJ;AAOI;EACE,4BAAA;AALN;AAMM;EACE,UAAA;AAJR;AAQE;EACE,kBAAA;EACA,WAAA;EACA,gCAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AANJ;AAQE;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,2BAAA;AANJ;AAOI;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AALN;AAMM;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,4BAAA;EACA,2BAAA;EACA,YAAA;EACA,kBAAA;AAJR;AAKQ;EACE,UAAA;EACA,wBAAA;EACA,WAAA;AAHV;AAKQ;EACE,+BAAA;AAHV;AAIU;EACE,UAAA;AAFZ","sourcesContent":["$TRANSITION_TIME: 0.5s;\n$PROGRESS_TIME: 1s;\n\n.ImageInput {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  position: relative;\n  .ImageInput-Placeholder {\n    opacity: 1;\n    transition: opacity $TRANSITION_TIME;\n  }\n  &:not(.ImageInput-Disabled) {\n    &:focus-within,\n    &:has(.ImageInput-Button:hover) {\n      .ImageInput-Placeholder {\n        opacity: 0;\n      }\n    }\n  }\n  &.ImageInput-Disabled .ImageInput-Button {\n    cursor: default;\n    &:hover {\n      background: rgba(0, 0, 0, 0);\n      > i {\n        opacity: 0;\n      }\n    }\n  }\n  .ImageInput-Progress {\n    position: absolute;\n    width: 100%;\n    transition: $PROGRESS_TIME height background;\n    font-size: 1rem;\n    color: #fff;\n    text-align: center;\n  }\n  .ImageInput-Display {\n    position: relative;\n    display: flex;\n    width: 100%;\n    height: 100%;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    overflow: hidden;\n    background-size: cover;\n    background-position: center;\n    .ImageInput-Overlay {\n      position: absolute;\n      width: 100%;\n      height: 100%;\n      .ImageInput-Button {\n        width: 100%;\n        height: 100%;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        background: rgba(0, 0, 0, 0);\n        transition: background $TRANSITION_TIME;\n        border: none;\n        font-size: inherit;\n        > i {\n          opacity: 0;\n          transition: opacity $TRANSITION_TIME;\n          color: #fff;\n        }\n        &:hover {\n          background: rgba(0, 0, 0, 0.25);\n          > i {\n            opacity: 1;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
